import { render, staticRenderFns } from "./modals-wrapper.vue?vue&type=template&id=a9b61388"
import script from "./modals-wrapper.vue?vue&type=script&lang=js"
export * from "./modals-wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports